import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useOrderNote } from '../OrderNoteContext';
import QuillWysiwyg from 'components/ui/QuillWysiwyg';

interface IProps {
  parentNoteId: number;
  taggedUsers?: any[];
  setReplyOpen?: (open: boolean) => void;
  fromThread?: boolean;
}

const ReplyStyles = styled.div`
  width: 690px;
  /* height: 48px; */
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  padding-right: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px;
  padding: 8px;
  /* color:#8e8e93; */
`;

const Reply = (props: IProps) => {
  const [replyNote, setReplyNote] = React.useState('');
  const { handleNewNoteSave, mentionOptions } = useOrderNote();
  return (
    <ReplyStyles
      onKeyDown={e => {
        // if (e.key === 'Enter') {
        //   handleNewNoteSave(replyNote, props.taggedUsers || [], props.parentNoteId);
        //   setReplyNote('');
        // }
      }}
    >
      {/* <input
        type="text"
        placeholder="Respond to note here"
        onChange={e => setReplyNote(e.target.value)}
        value={replyNote || ''}
      /> */}
      <QuillWysiwyg
        value={replyNote}
        maxheight={90}
        onChange={(e: any) => setReplyNote(e)}
        mentionValues={mentionOptions}
      />
      <div
        onClick={() => {
          handleNewNoteSave(replyNote, props.taggedUsers || [], props.parentNoteId);
          setReplyNote('');
          props.setReplyOpen && !props.fromThread && props.setReplyOpen(false);
        }}
        style={{
          color: '#8E8E93',
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'flex-end',
          paddingTop: 64,
        }}
      >
        Reply
      </div>
    </ReplyStyles>
  );
};

export default Reply;
